/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line


  




  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();
// Open external links in new tabs
document.addEventListener('DOMContentLoaded', function() {
  var links = document.querySelectorAll('a[href]');
  
  links.forEach(function(link) {
    var href = link.getAttribute('href');
    
    // Check if link is external (doesn't start with / and doesn't contain your domain)
    if (href && !href.startsWith('/') && !href.startsWith('#') && !href.includes(window.location.hostname)) {
      link.setAttribute('target', '_blank');
      link.setAttribute('rel', 'noopener noreferrer');
    }
  });
});

